import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const PreSelectWorkspaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PreSelectWorkspace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitOn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"MemberHeader"},{"kind":"EnumValue","value":"MemberBoards"}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmed"}},{"kind":"Field","name":{"kind":"Name","value":"enterpriseLicenses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idEnterprise"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idEnterprise"}},{"kind":"Field","name":{"kind":"Name","value":"organizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"products"}},{"kind":"Field","name":{"kind":"Name","value":"limits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"freeBoardsPerOrg"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"disableAt"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"PreSelectWorkspace","document":PreSelectWorkspaceDocument}} as const;
export type PreSelectWorkspaceQueryVariables = Types.Exact<{
  memberId: Types.Scalars['ID'];
}>;


export type PreSelectWorkspaceQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'confirmed' | 'id' | 'idEnterprise'>
    & { enterpriseLicenses?: Types.Maybe<Array<(
      { __typename: 'Member_EnterpriseLicense' }
      & Pick<Types.Member_EnterpriseLicense, 'idEnterprise' | 'type'>
    )>>, organizations: Array<(
      { __typename: 'Organization' }
      & Pick<Types.Organization, 'id' | 'name' | 'products'>
      & { limits: (
        { __typename: 'Organization_Limits' }
        & { orgs: (
          { __typename: 'Organization_Limits_Orgs' }
          & { freeBoardsPerOrg: (
            { __typename: 'Limit' }
            & Pick<Types.Limit, 'count' | 'disableAt'>
          ) }
        ) }
      ) }
    )> }
  )> }
);




/**
 * __usePreSelectWorkspaceQuery__
 *
 * To run a query within a React component, call `usePreSelectWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreSelectWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreSelectWorkspaceQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function usePreSelectWorkspaceQuery(baseOptions: Apollo.QueryHookOptions<PreSelectWorkspaceQuery, PreSelectWorkspaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreSelectWorkspaceQuery, PreSelectWorkspaceQueryVariables>(PreSelectWorkspaceDocument, options);
      }
export function usePreSelectWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreSelectWorkspaceQuery, PreSelectWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreSelectWorkspaceQuery, PreSelectWorkspaceQueryVariables>(PreSelectWorkspaceDocument, options);
        }
export type PreSelectWorkspaceQueryHookResult = ReturnType<typeof usePreSelectWorkspaceQuery>;
export type PreSelectWorkspaceLazyQueryHookResult = ReturnType<typeof usePreSelectWorkspaceLazyQuery>;
export type PreSelectWorkspaceQueryResult = Apollo.QueryResult<PreSelectWorkspaceQuery, PreSelectWorkspaceQueryVariables>;